<template>
  <div>
    <Head title="Descuentos" />
    <h1 class="mb-8 text-3xl font-bold">Descuentos</h1>
    <div class="flex items-center justify-between mb-6">
      <!-- <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Codigo:</label>
        <select v-model="form.code" class="form-select mt-1 w-full">
          <option :value="null" />
          <option v-for="code in codes" :key="code.id" :value="code.description">{{ code.description }}</option>
        </select>
      </search-filter> -->
      <Link class="btn-sky" href="/discounts/create">
        <span>Crear</span>
        <span class="hidden md:inline">&nbsp;Descuento</span>
      </Link>
    </div>
    
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 pl-6">Nombre</th>
          <th class="pb-4 pt-6 pl-6">Tipo de descuento</th>
          <th class="pb-4 pt-6 pl-6">Producto</th>
          <th class="pb-4 pt-6 pl-6">Periodo</th>
          <th class="pb-4 pt-6 pl-6">Tipo</th>
          <th class="pb-4 pt-6 pl-6">Condición</th>
          <th class="pb-4 pt-6 pl-6">Descuento/Regalia</th>
          <th class="pb-4 pt-6 pl-6">Opciones</th>
        </tr>
        <tr v-for="discount in discounts" :key="discount.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t pl-6">
            {{ discount.name }}
          </td>
          <td class="border-t pl-6">
            <span>
              {{ discount.type === 'simple' ? 'Sencillo' : 'Compuesto'  }}
            </span>

          </td>
          <td class="border-t pl-6">
            <!-- <template v-for="product in discount.products">
              <span>{{ product }}</span><br><br>
            </template> -->
            {{ discount.product }}
          </td>
          <td class="border-t pl-6">
            {{ discount.init_date }} - {{ discount.end_date ?? 'Indefinido' }}
          </td>
          <td class="border-t">
            {{ discount.discount_type }}
          </td>
          <td class="border-t">
            <span v-if="discount.discount_type=='Caja'" class="flex items-center px-6 py-4" :href="`/discounts/${discount.id}/edit`">{{ discount.condition }} caja(s)</span>
            <span v-else class="flex items-center px-6 py-4" :href="`/discounts/${discount.id}/edit`">{{ discount.condition }} caja(s)</span>
          </td>
          <td class="border-t">
            <span v-if="discount.discount_type=='Caja'" class="flex items-center px-6 py-4" :href="`/discounts/${discount.id}/edit`">{{ discount.product_discount }} caja(s)</span>
            <span v-else class="flex items-center px-6 py-4" :href="`/discounts/${discount.id}/edit`">${{ (Number(discount.product_discount)).toFixed(2) }}</span>
          </td>
          <td class="border-t pl-6">
            <div class="flex">
            <Link class="flex-1 items-center px-2 py-4" :href="`/discounts/${discount.id}/edit`">
              <button class="focus:outline-none text-white bg-green-500 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-900">
                Editar                        
              </button>
            </Link>
            <div class="flex-1 py-4">
              <button class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900" @click="removeDiscount(discount.id)">
                Eliminar                        
              </button> 
            </div>           
            </div>
          </td>
        </tr>
        <!-- <tr>
          <td class="px-6 py-4 border-t" colspan="3">No se encontraron descuentos</td>
        </tr> -->
      </table>
    </div>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Swal from 'sweetalert2'
  
export default {
  components: {
    Head,
    Link,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    discounts: Array,
    codes: Object,
    allProducts: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        code: this.filters.code,
      },
    }
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    removeDiscount(idDiscount){
      Swal.fire({
        title:'Remover Descuento',
        text:'¿Está seguro?',
        icon:'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Remover',
      }).then((result)=>{
        if(result.isConfirmed){
          this.$inertia.put(`/discounts/delete/${idDiscount}`)
        }
      });
    }
  },
}
</script>